// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1Bpsj","additionalInfo":"AgreementModal_additionalInfo__K5cm3"};